import axios from "axios";
import { toast } from "react-toastify";

const AnalyticsService = {
  getToken: async (personId , consentIds) => {
    const token = localStorage.getItem("user-token");

    let params = {personId, consentIds }
    var data = JSON.stringify(params);

    var config = {
      method: "post",
      maxBodyLength: Infinity,
      // url: process.env.REACT_APP_DELEND_API+'/superset-guest-token',
      url: 'https://dev.api.delend.com.br/api/superset-guest-token',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        toast.error(error.response);
        return error.response;
      });
  }
  ,
  getOrdersToken: async () => {
    const token = localStorage.getItem("user-token");
    const subscriptionId = localStorage.getItem("subscriptionId")
    let params = {subscriptionIds : [subscriptionId] , consentIds : [''] }
    var data = JSON.stringify(params);

    var config = {
      method: "post",
      maxBodyLength: Infinity,
      url: process.env.REACT_APP_DELEND_API+'/superset-guest-token',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        toast.error(error.response);
        return error.response;
      });
  }
} 

export default AnalyticsService;